import React from 'react';
import { useRouter } from 'next/router';
import { Card } from '@avila-tek/ui/src';
import { Title } from '../../shared';
import { Company, PaymentInfo, User } from '../../../models';
import { roles } from '../../../static';

interface ClientDetailProps {
  user: User;
  paymentInfo?: PaymentInfo;
  status?: string;
}

function ClientDetail({ user, paymentInfo, status }: ClientDetailProps) {
  const router = useRouter();
  const showPaymentInfo =
    paymentInfo &&
    !router.asPath.includes('receivable') &&
    user?.userType === roles.company &&
    status !== 'receivable';
  return (
    <Card className="p-4 sm:px-6 relative mt-5">
      <Title title="Detalles del cliente" />
      <div className="flex flex-wrap">
        <div className="w-full md:w-1/2 flex flex-col">
          <span className="text-purple-300 font-semibold">Empresa: </span>
          <span className="text-text-gray">
            {(user?.company as Company)?.name}
          </span>
          <span className="text-text-gray">
            {(user?.company as Company)?.dniType}-
            {(user?.company as Company)?.dni}
          </span>
          <span className="text-purple-300 font-semibold">
            Persona de contacto:{' '}
          </span>
          <span className="text-text-gray">
            {user?.firstName} {user?.lastName}
          </span>
          <span className="text-text-gray">
            {user?.dniType}-{user?.dni}
          </span>
          <span className="text-text-gray">+{user?.phone}</span>
          <span className="text-text-gray">{user?.email}</span>
        </div>
        {showPaymentInfo ? (
          <div className="w-full md:w-1/2 flex flex-col">
            <span className="text-purple-300 font-semibold text-lg">
              Información del pago
            </span>
            <span className="text-text-gray">
              {paymentInfo?.paymentMethod?.title}
            </span>
            <span className="text-text-gray">
              <span className="text-purple-300 font-semibold">
                Referencia:{' '}
              </span>
              {paymentInfo?.reference}
            </span>
          </div>
        ) : null}
      </div>
    </Card>
  );
}

export default ClientDetail;
